export const ROOT = "/admin/store";

export const SUBSCRIPTION_PLANS_PAGE = "/admin/store/subscription-plans";
export const PURCHASE_QR_CREDIT_PAGE = "/admin/store/purchase-qr-credit";
